import { IMilestoneTemplate } from "@/interfaces";

export const updateMilestoneRecursively = (
  milestoneToUpdate: IMilestoneTemplate,
  updateMilestoneTemplates: IMilestoneTemplate[]
): IMilestoneTemplate[] =>
  updateMilestoneTemplates.map((milestoneTemplate): IMilestoneTemplate => {
    const { id, childMilestones } = milestoneTemplate;
    if (id === milestoneToUpdate.id) {
      milestoneTemplate = { ...milestoneToUpdate };
    }
    return {
      ...milestoneTemplate,
      childMilestones: childMilestones?.length
        ? updateMilestoneRecursively(milestoneToUpdate, childMilestones)
        : childMilestones,
    };
  });
